import { render } from "./AccessibilityStatement.vue?vue&type=template&id=283eb2a7&scoped=true"
import script from "./AccessibilityStatement.vue?vue&type=script&lang=js"
export * from "./AccessibilityStatement.vue?vue&type=script&lang=js"

import "./AccessibilityStatement.vue?vue&type=style&index=0&id=283eb2a7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283eb2a7"]])

export default __exports__